import React from 'react'
import { Typography, Box } from '@mui/material'
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  // LineChart,
  // Line,
  Bar,
  BarChart,
  CartesianGrid,
} from 'recharts'

const CommonBarGraph = ({ chartData }: { chartData: any }) => {
  // Modify each entry in chartData before passing to BarChart
  const transformedData = chartData?.map((entry: any) => ({
    ...entry,
    range: entry?.max - entry?.min,
  }))

  const CustomTooltip = ({ payload, label }: any) => {
    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'start'}
        bgcolor='white'
        padding={2}
        border='1px solid grey'
        gap={1.3}
        borderRadius={5}
      >
        <Typography fontSize={'12px'} fontWeight={600}>
          {label}
        </Typography>
        {/* <Typography fontSize={'12px'} fontWeight={500}>
          Avg - {payload?.[0]?.payload?.avg}
        </Typography> */}
        <Typography fontSize={'12px'} fontWeight={500}>
          Min - {payload?.[0]?.payload?.min}
        </Typography>
        <Typography fontSize={'12px'} fontWeight={500}>
          Max - {payload?.[0]?.payload?.max}
        </Typography>
      </Box>
    )
  }

  return (
    <ResponsiveContainer width='100%' height={300}>
      <BarChart data={transformedData} margin={{ bottom: 40 }}>
        <XAxis
          dataKey='date'
          fontSize={'10px'}
          interval={0}
          angle={-45}
          textAnchor='end'
          tick={{ fontSize: 10 }}
        />
        <CartesianGrid strokeDasharray='3 3' />
        <YAxis domain={[0, 'dataMax']} fontSize='12px' />
        <Tooltip content={<CustomTooltip />} />

        {/* Transparent min height bar */}
        <Bar dataKey='min' stackId='a' fill='transparent' barSize={6} />

        {/* Filled range from min to max */}
        <Bar
          dataKey='range'
          stackId='a'
          fill='#4682b4'
          barSize={6}
          radius={[4, 4, 4, 4]}
        />
      </BarChart>
    </ResponsiveContainer>
  )
}

export default CommonBarGraph
